import { merge } from 'lodash'
import { remove, convert, sort } from './utils'
import AxiosBase from './axios-base'
import { apiDomain } from '@/lib/config'
class AxiosChain {
  constructor () {
    this.__params = {}
    this.__config = {}
    this.__axiosConfig = {
      timeout: 30000 // 请求超时时间
    }
    this.__requests = []
    this.__responses = []
    this.__netSuccesses = []
    this.__netCompletes = []
    this.__netFails = []
    this.__extends = []
  }
  _queue (to, data, name) {
    const { id, index } = convert(name)
    to.push({ id, index, val: data })
    return this
  }
  params (params = {}) {
    merge(this.__params, params)
    return this
  }
  getParams () {
    return this.__params
  }
  config (cfg = {}) {
    merge(this.__config, cfg)
    return this
  }
  getConfig () {
    return this.__config
  }
  axiosConfig (cfg = {}) {
    merge(this.__axiosConfig, cfg)
    return this
  }
  getAxiosConfig () {
    return this.__axiosConfig
  }
  onRequest (mixed, name) {
    return this._queue(this.__requests, mixed, name)
  }
  offRequest (name) {
    this.__requests = remove(this.__requests, name)
    return this
  }
  onResponse (mixed, name) {
    return this._queue(this.__responses, mixed, name)
  }
  offResponse (name) {
    this.__responses = remove(this.__responses, name)
    return this
  }
  onNetSuccess (func, name) {
    return this._queue(this.__netSuccesses, func, name)
  }
  offNetSuccess (name) {
    this.__netSuccesses = remove(this.__netSuccesses, name)
    return this
  }
  onNetFail (func, name) {
    return this._queue(this.__netFails, func, name)
  }
  removeFail (name) {
    this.__netFails = remove(this.__netFails, name)
    return this
  }
  onNetComplete (func, name) {
    return this._queue(this.__netCompletes, func, name)
  }
  offNetComplete (name) {
    this.__netCompletes = remove(this.__netCompletes, name)
    return this
  }
  extendProto (func) {
    func.call(this, AxiosBase.prototype)
    return this
  }
  extend (func, name) {
    return this._queue(this.__extends, func, name)
  }
  removeExtend (name) {
    this.__extends = remove(this.__extends, name)
    return this
  }
  getClass () {
    return AxiosBase
  }
  getProto () {
    return AxiosBase.prototype
  }
  create (url, method, baseURL, config) {
    if (baseURL) {
      this.axiosConfig({
        baseURL,
        withCredentials: true
      })
    } else {
      this.axiosConfig({
        baseURL: apiDomain,
        withCredentials: false
      })
    }

    const base = new AxiosBase({
      url,
      method,
      params: this.__params,
      config: this.__config,
      axiosConfig: this.__axiosConfig,
      requests: this.__requests,
      responses: this.__responses,
      netSuccesses: this.__netSuccesses,
      netFails: this.__netFails,
      netCompletes: this.__netCompletes
    })
    const insExtends = sort(this.__extends)
    insExtends.forEach(item => {
      const { val } = item
      val.call(this, base)
    })
    return base
  }
}
export default AxiosChain
